<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="provisioningEventList"
            :description="false"
            @selected="handleSelected2"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.DetailsOfEvent") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Event' })"
                  size="small"
                  >{{ $t("setup.label.CreateEvent") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.EventName") }}</vs-th>
              <vs-th>{{ $t("setup.label.EventDescription") }}</vs-th>
              <vs-th>{{ $t("setup.label.EventCategory") }}</vs-th>
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="provisioningEventList"
                v-for="(provisioningEventList, index) in data"
              >
                <vs-td :data="provisioningEventList.eventName">{{
                  provisioningEventList.eventName
                }}</vs-td>
                <vs-td :data="provisioningEventList.eventDescription">{{
                  provisioningEventList.eventDescription
                }}</vs-td>
                <vs-td :data="provisioningEventList.eventCategory">{{
                  provisioningEventList.eventCategory
                }}</vs-td>
                <vs-td :data="provisioningEventList.status">{{
                  provisioningEventList.status
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editEventHandle(provisioningEventList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        editJobsRumPopup = true;
                        delId = provisioningEventList.id;
                      "
                      class="icon_row"
                    />
                    <feather-icon
                      icon="PlusIcon"
                      :title="$t('setup.label.AddPrice')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="addEventPrice(provisioningEventList.id)"
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              :title="$t('setup.label.DeleteMediaEvent')"
              :active.sync="editJobsRumPopup"
              class="popup-close small-popup"
            >
              <div class="center">
                <img src="@/assets/images/pages/delete.svg" />
                <div class="success-msg">
                  {{ $t("system.label.areYouSureDelete") }}
                </div>
              </div>

              <div class="center">
                <span class="p-2">
                  <vs-button type="border" @click="editJobsRumPopup = false">{{
                    $t("system.label.cancel")
                  }}</vs-button></span
                >

                <span class="p-2">
                  <vs-button @click="handleDeleteEvent(delId)">{{
                    $t("system.label.confirm")
                  }}</vs-button>
                </span>
              </div>
              <div style="height: 20px"></div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";

const teamEmptyObj = {
  mediaName: "",
  atb1: "",
  atb2: "",
  atb3: "",
  atb4: "",
  attribureDetailDatas: [],
  categoryType: "",
};
const locationEmptyObj = {
  mediaName: "",
  mCodeValue: "",
  location1: "",
  locationsDetailDatas: [],
  categoryType: "",
};
export default {
  data() {
    return {
      activeTab: 0,
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      mediaAttributes: [],
      mediaLanguageData: [],
      mediaFormat: [],
      attributes: teamEmptyObj,
      locations: locationEmptyObj,
      mediaLocationPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
  },

  computed: {
    ...mapState({
      hardwareMediaList: (state) => state.mediaDetails.Medialist,
      provisioningEventList: (state) => state.mediaDetails.Eventlist,
      template: (state) => state.mediaDetails.AddAttributeTemplateList,
    }),
  },
  methods: {
    async getEventListData() {
      try {
        await this.$store.dispatch("mediaDetails/setEventList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editEventHandle(id) {
      this.$router.push({ name: "Edit Event", params: { id: id } });
    },
    async handleDeleteEvent(id) {
      try {
        this.editJobsRumPopup = false;
        await this.$store.dispatch("mediaDetails/deleteEventAction", id);
        this.getEventListData();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Event Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    // async deleteRumTeam(id) {
    // },

    addEventPrice(eventId) {
      const id = eventId;
      this.$router.push({ name: "Add Price", params: { id: id } });
    },
  },
  async mounted() {
    this.loading = true;

    this.getEventListData();

    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 50%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.under_input {
  width: 140px;
}
</style>
